export enum Modes {
  Edit = 'edit',
  Create = 'create'
}
